import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

export interface BulkInviteResult {
  email: string
  status: 'invited' | 'reinvited' | 'error'
  error?: 'already_exists' | 'already_exists_in_another_account' | 'unknown_error'
}

interface BulkInviteParams {
  users: { email: string; role: string }[]
  locale: string
}

interface BulkInviteResponse {
  results: BulkInviteResult[]
}

export function useInviteUsersBulkMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ users, locale }: BulkInviteParams) =>
      fetchApi<BulkInviteResponse>({
        endpoint: '/api/users/invite/bulk',
        method: 'POST',
        body: { users, locale },
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['users', 'list'] })
    },
  })
}
